module.exports = __webpack_public_path__ + "img/wuxvzhifuing.5e6c59d5.png";